import { render, staticRenderFns } from "./PtSheet.vue?vue&type=template&id=0b049add&scoped=true&"
import script from "./PtSheet.vue?vue&type=script&lang=js&"
export * from "./PtSheet.vue?vue&type=script&lang=js&"
import style0 from "./PtSheet.vue?vue&type=style&index=0&id=0b049add&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b049add",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VDivider,VIcon,VSheet,VTooltip})
